import clsx from 'clsx';
import { useField } from 'formik';
import { ErrorMessage } from 'formik';
import { FC } from 'react';
import styles from './FormErrorBag.module.scss';

interface Props {
    name: string;
    withBorder?: boolean;
    className?: string;
}

export const FormErrorBag: FC<Props> = ({
    name,
    withBorder = false,
    className,
    children,
}) => {
    const [, meta] = useField(name);
    const hasError = meta.touched && meta.error;
    return (
        <div
            className={clsx(
                styles.error,
                hasError && withBorder && styles.border,
                className
            )}
        >
            <div>{children}</div>
            <ErrorMessage
                component="div"
                name={name}
                className={styles.message}
            />
        </div>
    );
};
